import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleListSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full tracking-wide uppercase mb-4">
            SEO Guides & Articles
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            OOPBuy Spreadsheet Complete Guides
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Explore our comprehensive collection of OOPBuy Spreadsheet guides — from getting started tutorials and safety information to detailed product category overviews and comparison articles.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:bg-background-100/80 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/9]">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span>June 2026</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-foreground-950 font-heading text-lg md:text-xl font-semibold leading-snug group-hover:text-accent-700 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="mt-3 text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-accent-600 text-sm font-medium">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-xs transition-transform duration-200 group-hover:translate-x-1"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/article/how-to-use-oopbuy-spreadsheet"
            className="btn-primary text-sm inline-flex items-center gap-2"
          >
            <i className="ri-book-open-line"></i>
            Start with the Beginner Guide
          </Link>
        </div>
      </div>
    </section>
  );
}